module.exports = __webpack_public_path__ + "static/media/sample_filter_wireframe.de553878.png";